function removeBumpFromColumnComponents (components, { moveBumpsInsideForm }) {
  const columnEarlyRenewals = []
  const columnBumps = []

  const newComponents = components.filter((component) => {
    if (component.name === 'hotpay-order-bump') {
      columnBumps.push(component)

      return !moveBumpsInsideForm
    }

    if (component.name === 'hotpay-early-renewal') {
      columnEarlyRenewals.push(component)
    }

    return true
  })

  return {
    newComponents,
    columnBumps,
    columnEarlyRenewals
  }
}

function removeBumpFromRowColumns (columns, { moveBumpsInsideForm }) {
  const rowEarlyRenewals = []
  const rowBumps = []

  const newColumns = columns.reduce((newRowColumns, currentColumn) => {
    const { columnBumps, columnEarlyRenewals, newComponents } =
      removeBumpFromColumnComponents(currentColumn.components, { moveBumpsInsideForm })

    rowBumps.push(...columnBumps)
    rowEarlyRenewals.push(...columnEarlyRenewals)

    const columnStillHasComponentsAfterRemovingBump = !!newComponents.length

    if (columnStillHasComponentsAfterRemovingBump) {
      newRowColumns.push({ ...currentColumn, components: newComponents })
    }

    return newRowColumns
  }, [])

  return {
    newColumns,
    rowBumps,
    rowEarlyRenewals
  }
}

export function removeBumpFromPayloadRows (rows, { moveBumpsInsideForm } = {}) {
  const bumpsOutOfForm = []
  const earlyRenewalsOutOfForm = []

  const newRows = rows.reduce((payloadRows, currentRow) => {
    const { newColumns, rowBumps, rowEarlyRenewals } = removeBumpFromRowColumns(currentRow.columns, { moveBumpsInsideForm })

    bumpsOutOfForm.push(...rowBumps)
    earlyRenewalsOutOfForm.push(...rowEarlyRenewals)

    const rowStillHasColumnsAfterRemovingBump = !!newColumns.length

    if (rowStillHasColumnsAfterRemovingBump) {
      payloadRows.push({ ...currentRow, columns: newColumns })
    }

    return payloadRows
  }, [])

  return {
    newRows,
    bumpsOutOfForm,
    earlyRenewalsOutOfForm
  }
}
